// extracted by mini-css-extract-plugin
module.exports = {"chat_card":"messenger_chat_card__BuRos","chat_card_icon":"messenger_chat_card_icon__fhfDi"};